import type { FC, ReactNode } from "react";
import {
  Card,
  Flex,
  Grid,
  IconButton,
  Tooltip,
  type HouseRecord,
} from "@huub-web/ui";
import { mergeClasses } from "@huub-web/utils";

import { HouseDisplayCard } from "../HouseDisplayCard";
import { ChanceCard } from "../ChanceCard";

import {
  houseCardStyle,
  trailingCardStyle,
  trailingCardContentStyle,
  chanceCardStyle,
  chanceCardBottomStyle,
  trailingGridStyle,
  trailingMainCardContentStyle,
} from "./HouseHeader.css";

export type HouseHeaderProps = {
  record?: HouseRecord;
  card?: ReactNode;
  hasPartner?: boolean;
  chanceCardCTA?: ReactNode;
  leading?: ReactNode;
  savable?: boolean;
  saved?: boolean;
  disabled?: boolean;
  titleTrailing?: ReactNode;
  onSaveToggle?: () => void;
};

export const HouseHeader: FC<HouseHeaderProps> = ({
  record,
  card,
  hasPartner,
  chanceCardCTA,
  leading,
  savable,
  saved,
  disabled,
  titleTrailing,
  onSaveToggle,
}) => (
  <>
    {record ? (
      <HouseDisplayCard
        titleTrailing={
          <>
            {titleTrailing}
            {savable && (
              <Tooltip
                value={saved ? "Verwijder deze woning" : "Bewaar deze woning"}
              >
                <IconButton
                  icon={saved ? "delete" : "like"}
                  variant="opaque"
                  border="default"
                  size="s"
                  onClick={() => onSaveToggle?.()}
                  disabled={disabled}
                  data-id={saved ? "house-delete" : "house-save"}
                />
              </Tooltip>
            )}
          </>
        }
        className={houseCardStyle()}
        record={record}
        leading={leading}
        trailing={
          (card || chanceCardCTA) && (
            <Card variant="blur" className={trailingCardStyle} padding="xs">
              <Grid
                variant="twoColumn"
                className={trailingGridStyle({
                  hasTwoColumns: !!chanceCardCTA,
                })}
              >
                {card && (
                  <Flex
                    className={trailingMainCardContentStyle()}
                    grow
                    direction="column"
                    gap="xs"
                  >
                    {card}
                  </Flex>
                )}
                {chanceCardCTA && (
                  <ChanceCard
                    innerClassName={mergeClasses(
                      trailingCardStyle,
                      chanceCardStyle,
                    )}
                    hasPartner={hasPartner}
                    cta={chanceCardCTA}
                  />
                )}
              </Grid>
            </Card>
          )
        }
      />
    ) : (
      <Grid
        variant="none"
        className={trailingGridStyle({ hasTwoColumns: !!chanceCardCTA })}
      >
        <Card
          innerClassName={trailingCardStyle}
          contentClassName={trailingCardContentStyle}
          border="default"
        >
          {card}
        </Card>
        {chanceCardCTA && (
          <ChanceCard
            innerClassName={mergeClasses(trailingCardStyle, chanceCardStyle)}
            hasPartner={hasPartner}
            cta={chanceCardCTA}
          />
        )}
      </Grid>
    )}
    {chanceCardCTA && (
      <ChanceCard
        className={chanceCardBottomStyle}
        innerClassName={trailingCardStyle}
        hasPartner={hasPartner}
        cta={chanceCardCTA}
      />
    )}
  </>
);
